module.exports = __webpack_public_path__ + "static/media/test_communication.75f9d5ad.png";